/**
 * Cerca — reorder attribution.
 *
 * Reads cs_source / cs_reorder_order / cs_reorder_order_id off the URL when a
 * shopper arrives from WordPress and writes them into the Shopify cart
 * attributes. Cart attributes survive cart -> checkout -> order and land on
 * the order as note_attributes, which the backend already reads.
 *
 * Self-contained on purpose: it touches no other theme file and depends on
 * nothing but /cart/update.js, so wp-cart-sync-script-2.js can change without
 * this needing to.
 *
 * Safe alongside that script: /cart/update.js sets only the keys you give it
 * and leaves the rest alone, so the cs_user_id it writes is untouched.
 * Verified on the live store — an attribute written on arrival was still
 * present after the cart sync ran, after /cart/add.js, and after a quantity
 * change.
 */
(function () {
  'use strict';

  // A second copy of this file, or a leftover inline paste, must not double-run.
  if (window.__csReorderStamped) return;
  window.__csReorderStamped = true;

  var ALLOWED = ['reorder'];
  var KEY     = 'cs_reorder_pending';
  var MAX_AGE = 24 * 60 * 60; // seconds

  function nowSec() {
    return Math.floor(Date.now() / 1000);
  }

  /**
   * From the URL on the landing hit, then from sessionStorage on every page
   * after it — the parameters are gone the moment the shopper clicks anything,
   * but the cart may not be built yet when they arrive.
   *
   * sessionStorage rather than localStorage: attribution should die with the
   * tab, not follow someone into next week's unrelated purchase.
   */
  function read() {
    try {
      var params = new URLSearchParams(window.location.search);
      var source = params.get('cs_source');

      if (source && ALLOWED.indexOf(source) !== -1) {
        var fresh = {
          source: source,
          name: params.get('cs_reorder_order') || null,
          orderId: params.get('cs_reorder_order_id') || null,
          at: nowSec()
        };
        sessionStorage.setItem(KEY, JSON.stringify(fresh));
        return fresh;
      }

      var saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (!saved || ALLOWED.indexOf(saved.source) === -1) return null;

      if (nowSec() - (saved.at || 0) > MAX_AGE) {
        sessionStorage.removeItem(KEY);
        return null;
      }

      return saved;
    } catch (err) {
      // Private browsing, or a corrupt value. Attribution is reporting; it must
      // never be able to block a purchase.
      return null;
    }
  }

  function stamp() {
    var marker = read();
    if (!marker) return;

    var attributes = { cs_source: marker.source };
    if (marker.name) attributes.cs_reorder_order = marker.name;
    if (marker.orderId) attributes.cs_reorder_order_id = marker.orderId;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attributes })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        console.log('[cerca] reorder attribution stamped', cart && cart.attributes);
      })
      .catch(function (err) {
        console.warn('[cerca] reorder attribution failed', err);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stamp);
  } else {
    // Already parsed — a deferred script can land here.
    stamp();
  }

  /**
   * Belt and braces for themes that rebuild the cart and drop attributes.
   * Dawn publishes cart changes through pubsub.js rather than DOM events, so
   * these usually never fire here — they cost nothing and cover a theme change
   * later. The load-time stamp above is what actually does the work; it was
   * measured to survive the WP cart sync, an add, and a quantity update.
   */
  document.addEventListener('cart:updated', stamp);
  document.addEventListener('cart:refresh', stamp);
})();